import {z} from 'zod';

import {BaseVehicleValidationSchema} from './BaseVehicleValidationSchema';

export const RentalVehicleValidationSchema = BaseVehicleValidationSchema.extend({
  rentalProperties: z.object({
    carParkId: z.string(),
    vehicleCategoryId: z.string().nullable().optional(),
    availability: z.object({
      from: z.string().nullable().default(null),
      to: z.string().nullable().default(null),
      mileageLimit: z.number().nullable().default(null),
    }),
    note: z.string().nullable().default(null),
    equipment: z.array(z.string()).default([]),
    rentalPriceGroup: z
      .object({
        rentalPriceGroupId: z.string(),
        rentalPriceGroupItemId: z.string(),
      })
      .nullable(),
  }),
});

export type RentalVehicleValidationSchemaType = z.infer<typeof RentalVehicleValidationSchema>;
